import Component from 'flarum/common/Component';
import { fmt, periodLabel } from './format';
const COLORS = ['#1b4540', '#e76f51', '#2a9d8f', '#6c5ce7', '#e9c46a', '#264653'];

/** A small SVG line chart for country time series (no chart library). attrs: series, unit, hidden {id: true} */
export default class LineChart extends Component {
  view() {
    const {
      series,
      unit,
      hidden = {}
    } = this.attrs;
    const visible = series.filter(s => !hidden[s.id] && s.points.length);
    const periods = Array.from(new Set(series.flatMap(s => s.points.map(p => p.period)))).sort();
    if (!visible.length || !periods.length) return m("p", {
      className: "DataHubPub-muted"
    }, "Nothing to chart yet.");
    const W = 640,
      H = 260,
      L = 48,
      R = 16,
      T = 14,
      B = 34;
    const values = visible.flatMap(s => s.points.map(p => p.value));
    let min = Math.min(...values),
      max = Math.max(...values);
    if (min === max) {
      min -= 1;
      max += 1;
    }
    const pad = (max - min) * 0.1;
    min = min >= 0 ? Math.max(0, min - pad) : min - pad; // never below zero unless the data is
    max += pad;
    const x = p => L + (periods.length === 1 ? (W - L - R) / 2 : periods.indexOf(p) / (periods.length - 1) * (W - L - R));
    const y = v => T + (1 - (v - min) / (max - min)) * (H - T - B);
    const ticks = [0, 1, 2, 3].map(i => min + (max - min) * i / 3);
    const labelEvery = Math.max(1, Math.ceil(periods.length / 6));
    return m("svg", {
      className: "DataHubPub-chart",
      viewBox: `0 0 ${W} ${H}`,
      role: "img",
      "aria-label": "Chart"
    }, ticks.map(t => [m("line", {
      x1: L,
      x2: W - R,
      y1: y(t),
      y2: y(t),
      className: "DataHubPub-grid"
    }), m("text", {
      x: L - 6,
      y: y(t) + 4,
      "text-anchor": "end",
      className: "DataHubPub-axis"
    }, fmt(t, unit))]), periods.map((p, i) => i % labelEvery === 0 || i === periods.length - 1 ? m("text", {
      x: x(p),
      y: H - 10,
      "text-anchor": "middle",
      className: "DataHubPub-axis"
    }, periodLabel(p)) : null), series.map((s, si) => {
      if (hidden[s.id] || !s.points.length) return null;
      const color = COLORS[si % COLORS.length];
      const pts = s.points.map(p => `${x(p.period)},${y(p.value)}`).join(' ');
      return m("g", null, this.attrs.area && s.points.length > 1 ? m("polygon", {
        points: `${x(s.points[0].period)},${H - B} ${pts} ${x(s.points[s.points.length - 1].period)},${H - B}`,
        fill: color,
        "fill-opacity": "0.12",
        stroke: "none"
      }) : null, s.points.length > 1 ? m("polyline", {
        points: pts,
        fill: "none",
        stroke: color,
        "stroke-width": "2.5",
        "stroke-linejoin": "round"
      }) : null, s.points.map(p => m("circle", {
        cx: x(p.period),
        cy: y(p.value),
        r: "3.5",
        fill: color
      }, m("title", null, s.name + ', ' + periodLabel(p.period) + ': ' + fmt(p.value, unit)))));
    }));
  }
}
export { COLORS };